import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';
import { ImportType } from '../../../../../../../../components/csv-import/data/types/import-type';
import { useImportContext } from '../../../../../../../../components/csv-import/ui/components/import-context';
import { useStepDetectiveContext } from '../../../../../../../../components/csv-import/ui/components/step-detective/step-detective-context';
import { useCanStartImport } from '../../../../../../../../components/csv-import/ui/hooks/use-can-start-import';
import { addMetadataToImport } from '../../../../../../../../store/csv-import/csv-import.actions';
import { useInventorySyncContext } from '../../../../context/inventory-sync-context';
import { INVENTORY_MANUAL_MANAGEMENT_SUBSTEPS } from '../../../../context/inventory-sync-context/inventory-manual-management-substeps';

/**
 * @param {object} props
 * @param {() => void} props.onPrevClick - Function to handle previous button click
 * @returns {React.JSX.Element}
 */
export const MappingImportStepFooter = ({ onPrevClick }) => {
  const { onImport, isImportLoading, validateUserMapping, isMappingResultValid, initRequest } = useImportContext();
  const { updateInventorySubstep } = useInventorySyncContext();

  const { goToNext } = useStepDetectiveContext();

  const dispatch = useDispatch();

  const onImportClick = () => {
    const isValid = validateUserMapping();
    if (!isValid || !isMappingResultValid) {
      return;
    }

    const onSuccess = () => {
      dispatch(
        addMetadataToImport({
          importType: ImportType.productWithInventory,
          metadata: {
            fileName: initRequest.csvFile.name,
          },
        }),
      );
      goToNext();
      updateInventorySubstep(INVENTORY_MANUAL_MANAGEMENT_SUBSTEPS.importResultAndInventorySync);
    };

    onImport(onSuccess);
  };

  const isStartImportBtnDisabled = useCanStartImport();

  return (
    <>
      <Button className={styles['back-btn']} disabled={isImportLoading} onClick={onPrevClick} theme={THEME_CONSTANTS.link}>
        <FontAwesomeIcon className={styles.icon} icon={faArrowLeft} />
        <FormattedMessage {...messages.backBtn} />
      </Button>
      <Button
        className={styles['continue-btn']}
        disabled={isStartImportBtnDisabled}
        onClick={onImportClick}
        theme={THEME_CONSTANTS.primary}
      >
        <FormattedMessage {...messages.startImportBtn} />
      </Button>
    </>
  );
};
